import { Receipt } from 'lucide-react';

import { cn } from '@/lib/cn';

/** Gradient app mark; also used on the boot and error screens. */
export function BrandMark({ size = 'md', className }: { size?: 'md' | 'lg'; className?: string }) {
  return (
    <span
      className={cn(
        'bg-brand inline-flex shrink-0 items-center justify-center text-white shadow-[0_6px_16px_-4px_rgb(79_70_229/0.55)]',
        size === 'lg' ? 'size-14 rounded-2xl' : 'size-9 rounded-xl',
        className
      )}
      aria-hidden="true"
    >
      <Receipt size={size === 'lg' ? 26 : 17} strokeWidth={2.3} />
    </span>
  );
}

export function Brand() {
  return (
    <span className="flex items-center gap-2.5">
      <BrandMark />
      <span className="leading-tight">
        <span className="block text-[15px] font-bold tracking-tight">GroupExp</span>
        <span className="block text-[11px] font-medium text-muted">Shared expenses</span>
      </span>
    </span>
  );
}
